import React, { useState } from "react";
import {Grid } from '@material-ui/core';
import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import axios from "../../../components/axios";
import { useNavigate } from 'react-router-dom';


const UploadButtonCommon = ({ styleButton, handleUploadImage, fileName, setFileName }) => {
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(true);
  const [fileNameLeng, setFileNameLeng] = useState(7);
  const [file, setFile] = useState(null);
  const onChange = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };
  const onSubmit = async (e) => {

    const formData = new FormData();
    formData.append("upload-image", file);
    axios.post("/peloton/v1/automation/nestling-image-upload", formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
    })
    .then(response => {
      if (response.data.message === "success") {
        setFileName(response.data.path);
        setShowButton(false);
        setFileNameLeng(12);
        alert("Upload success");
      }else{
        alert(response.data.message);
      }
    })
    .catch(function(err){
      if (!err.response){
        alert(err);
      }else{
        if (err.response.status === 401){
          alert(err.response.data.message);
          navigate("/");
        }else{
          console.log('error.response.status: ', err.response.status);
          console.log('error.response.status: ', err.response.data.message);
          alert(err.response.data.message);
        }
      }
    })

  };

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });



  return (
    <>
    <form onSubmit={onSubmit}>
    <Grid container direction="row">
      <Grid item xs={fileNameLeng} zeroMinWidth>
        <Typography noWrap>{fileName}</Typography>
      </Grid>
      { showButton && (<Grid item xs={3}>
       <Button
        style={styleButton}
        component="label"
        variant="contained"
        tabIndex={-1}
        onChange={onChange}
      >
      select file
      <VisuallyHiddenInput type="file" />
      </Button>
    </Grid>)}
    { showButton && (<Grid item xs={2}>
      <Button
        style={styleButton}
        type="submit"
        variant="contained"
        tabIndex={-1}
      >
      Upload
      </Button>
    </Grid>)}
    </Grid>
    </form>
    </>
  );
};

export default UploadButtonCommon;
